import Vue from 'vue'
import App from './App'
import { router } from '@/router/router'
import store from '@/vuex/index.js'

import '@/main.css'
// 接收信息
import { getDict } from '@/utils/index'
import cookies from 'vue-cookies'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import { Cell, CellGroup, Uploader, NavBar, Button, Field,DatetimePicker , ActionSheet,Icon ,Dialog , Toast, Overlay,Rate , Notify, DropdownMenu, DropdownItem,Checkbox, CheckboxGroup } from 'vant';


Vue.prototype.Emit = new Vue();
Vue.use(ElementUI, { size: 'small' })

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(Toast)
Vue.use(ActionSheet)
Vue.use(Rate)
Vue.use(Notify);
Vue.use(Icon);
Vue.use(Overlay);
Vue.use(DatetimePicker);
Vue.use(Dialog);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Field)
Vue.use(Button)
Vue.use(NavBar)
Vue.use(Cell);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(CellGroup);
Vue.use(Uploader);
Vue.use(Notify)
Vue.prototype.$getDict = getDict;
Vue.prototype.$cookies = cookies;
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})
